module.exports = __webpack_public_path__ + "img/EconomyTabRollover_ua.99033414.webp";